import IRootPageLink from '@/types/IRootPageLink';
import { useDisclosure } from '@chakra-ui/react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IArgs {
	links: Array<IRootPageLink>;
	onChange: (v: { links: Array<IRootPageLink> }) => Promise<void>;
}

export function useSectionLinks(args: IArgs) {
	const { t } = useTranslation();
	const { isOpen, onOpen, onClose } = useDisclosure();

	const form = useForm({
		defaultValues: {
			links: args.links,
		},
	});

	const { append, remove, update } = useFieldArray({
		control: form.control,
		name: 'links',
	});

	function handleAddLink(values: IRootPageLink) {
		append({ ...values });
		return args.onChange(form.watch());
	}

	function handleLinkChange(index: number, link: IRootPageLink) {
		update(index, link);
		return args.onChange(form.watch());
	}

	function handleLinkDelete(index: number) {
		remove(index);
		return args.onChange(form.watch());
	}

	return {
		t,
		isOpen,
		onOpen,
		onClose,
		handleAddLink,
		handleLinkChange,
		handleLinkDelete,
	};
}
